var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { MathUtils } from 'three';
import { CURATOR_URL } from '../api/urls';
class Oauth {
    constructor() {
        this.disposeCalls = [];
        this.button = document.getElementById('oauth-button');
        this.button.classList.remove('is-hidden');
        {
            this.icon = document.createElement('span');
            this.icon.className = 'oauth-button-icon';
            this.button.appendChild(this.icon);
        }
        {
            const onClick = () => this.click();
            this.button.addEventListener('click', onClick);
            this.disposeCalls.push(() => this.button.removeEventListener('click', onClick));
        }
        this.loaded = this.checkStatus();
    }
    tryReceiveToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const sessionUuid = this.getCookie('session_uuid');
            if (!sessionUuid)
                return;
            const url = `${CURATOR_URL}/oauth/receive_token`;
            try {
                const result = yield fetch(url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        session_uuid: sessionUuid
                    })
                });
                const json = yield result.json();
                const accessToken = json.access_token;
                if (accessToken !== undefined) {
                    const expiration = new Date();
                    expiration.setHours(expiration.getHours() + 96); // TODO: sync with the JWT expiration time
                    this.setCookie('access_token', json.access_token, expiration);
                }
            }
            finally {
                this.deleteCookie('session_uuid');
            }
        });
    }
    loadUserInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            const accessToken = this.getCookie('access_token');
            if (!accessToken)
                return;
            const url = `${CURATOR_URL}/oauth/info`;
            const result = yield fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },
                body: JSON.stringify({
                    access_token: accessToken
                })
            });
            if (result.ok)
                return (yield result.json());
            else
                return undefined;
        });
    }
    checkStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, _reject) => __awaiter(this, void 0, void 0, function* () {
                try {
                    yield this.tryReceiveToken();
                    this.userInfo = yield this.loadUserInfo();
                    this.updateButtonIcon();
                    resolve(undefined);
                }
                catch (e) {
                    resolve(e);
                }
            }));
        });
    }
    updateButtonIcon() {
        var _a, _b;
        const provider = (_b = (_a = this.userInfo) === null || _a === void 0 ? void 0 : _a.provider) === null || _b === void 0 ? void 0 : _b.toLowerCase();
        const iconName = provider ? Oauth.PROVIDER_ICONS[provider] : undefined;
        if (iconName) {
            this.icon.style.setProperty('--oauth-provider-icon', `url('/assets/img/icons/${iconName}.svg')`);
            this.icon.classList.add('oauth-button-icon--provider');
        }
        else {
            this.icon.classList.remove('oauth-button-icon--provider');
            this.icon.style.removeProperty('--oauth-provider-icon');
        }
    }
    signOut() {
        this.userInfo = undefined;
        this.deleteCookie('access_token');
        this.updateButtonIcon();
        this.hideUserInfo();
    }
    click() {
        this.loaded.then(() => {
            if (this.userInfo === undefined)
                this.redirectToSignIn();
            else
                this.showUserInfo();
        });
    }
    redirectToSignIn() {
        var _a;
        const uuid = MathUtils.generateUUID();
        {
            const expiration = new Date();
            expiration.setHours(expiration.getHours() + 1);
            this.setCookie('session_uuid', uuid, expiration);
        }
        const redirect = window.location.href;
        const url = new URL('https://auth.dev-v2.spheresdev.co.uk/oauth'); // TODO: put in an .env
        url.searchParams.set('redirect_uri', btoa(redirect));
        url.searchParams.set('session_uuid', uuid);
        const currentParams = new URLSearchParams(window.location.search);
        if (currentParams.has('instagram')) {
            url.searchParams.set('instagram', (_a = currentParams.get('instagram')) !== null && _a !== void 0 ? _a : '');
        }
        window.location.href = url.toString();
    }
    showUserInfo() {
        var _a, _b;
        if (this.popup) {
            this.hideUserInfo();
            return;
        }
        const popup = document.createElement('div');
        popup.className = 'oauth-popup';
        {
            const title = document.createElement('div');
            title.className = 'oauth-popup-title';
            title.textContent = (_b = (_a = this.userInfo.email) !== null && _a !== void 0 ? _a : this.userInfo.nickname) !== null && _b !== void 0 ? _b : '';
            popup.appendChild(title);
        }
        {
            const provider = document.createElement('div');
            provider.className = 'oauth-popup-provider';
            const providerName = this.userInfo.provider;
            const iconName = Oauth.PROVIDER_ICONS[providerName === null || providerName === void 0 ? void 0 : providerName.toLowerCase()];
            if (iconName) {
                const icon = document.createElement('span');
                icon.className = 'oauth-popup-provider-icon';
                icon.style.setProperty('--oauth-provider-icon', `url('/assets/img/icons/${iconName}.svg')`);
                provider.appendChild(icon);
            }
            const text = document.createElement('div');
            text.className = 'oauth-popup-provider-text';
            const label = document.createElement('span');
            label.className = 'oauth-popup-provider-label';
            label.textContent = 'Connected with';
            text.appendChild(label);
            const name = document.createElement('span');
            name.className = 'oauth-popup-provider-name';
            name.textContent = providerName;
            text.appendChild(name);
            provider.appendChild(text);
            popup.appendChild(provider);
        }
        {
            const logOut = document.createElement('button');
            logOut.className = 'oauth-popup-log-out';
            const icon = document.createElement('span');
            icon.className = 'oauth-popup-log-out-icon';
            logOut.appendChild(icon);
            const text = document.createElement('span');
            text.textContent = 'Log out';
            logOut.appendChild(text);
            logOut.onclick = () => this.signOut();
            popup.appendChild(logOut);
        }
        {
            const rect = this.button.getBoundingClientRect();
            popup.style.position = 'fixed';
            popup.style.top = `${rect.bottom}px`;
            popup.style.right = `${window.innerWidth - rect.right}px`;
        }
        document.body.appendChild(popup);
        this.popup = popup;
        const onOutsideClick = (e) => {
            const target = e.target;
            if (!popup.contains(target) && !this.button.contains(target))
                this.hideUserInfo();
        };
        document.addEventListener('click', onOutsideClick, true);
        this.closePopup = () => document.removeEventListener('click', onOutsideClick, true);
    }
    hideUserInfo() {
        var _a, _b;
        (_a = this.closePopup) === null || _a === void 0 ? void 0 : _a.call(this);
        this.closePopup = undefined;
        (_b = this.popup) === null || _b === void 0 ? void 0 : _b.remove();
        this.popup = undefined;
    }
    // TODO: move cookie methods to a util file, use CookieStore if available
    getCookie(name) {
        var _a;
        return (_a = document.cookie
            .split('; ')
            .find(row => row.startsWith(`${name}=`))) === null || _a === void 0 ? void 0 : _a.split('=')[1];
    }
    setCookie(name, value, expiration) {
        const expires = 'expires=' + expiration.toUTCString();
        document.cookie = `${name}=${value};${expires};path=/`;
    }
    deleteCookie(name) {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
    dispose() {
        this.hideUserInfo();
        this.disposeCalls.forEach(it => it());
    }
}
Oauth.PROVIDER_ICONS = {
    google: 'google',
    instagram: 'instagram'
};
export default Oauth;
